import { Route, Routes } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { CanDeactivateGuard } from '@shared/guards/can-deactivate.guard';

import { BudgetPageComponent } from './budget-page.component';
import { BudgetEnhancedComponent } from './tabs/budget/budget-enhanced/budget-enhanced.component';
import { BudgetLibraryComponent } from './tabs/budget/budget-library/budget-library.component';
import { BudgetLibraryGuard } from './tabs/budget/budget-library/guards/budget-library.guard';
import { BudgetComponent } from './tabs/budget/budget.component';
import { ChangeOrderComponent } from './tabs/change-orders/change-order/change-order.component';
import { ChangeOrderGuard } from './tabs/change-orders/change-order/guards/change-order.guard';
import { ChangeOrderDetailComponent } from './tabs/change-orders/change-order-detail/change-order-detail.component';
import { ChangeOrdersComponent } from './tabs/change-orders/change-orders.component';
import { CisLogComponent } from './tabs/change-orders/cis-log/cis-log.component';
import { ChangeLogGuard } from './tabs/change-orders/cis-log/guards/change-log.guard';
import { CompareNewComponent } from './tabs/change-orders/compare-new/compare-new.component';
import { CompareGuard } from './tabs/change-orders/compare-new/guards/compare.guard';
import { PaymentMilestonesGuard } from './tabs/payments/payment-milestones/guards/payment-milestones.guard';
import { PaymentMilestonesComponent } from './tabs/payments/payment-milestones/payment-milestones.component';
import { PaymentScheduleGuard } from './tabs/payments/payment-schedule/guards/payment-schedule.guard';
import { PaymentScheduleComponent } from './tabs/payments/payment-schedule/payment-schedule.component';
import { PaymentsComponent } from './tabs/payments/payments.component';
import { PurchaseOrdersGuard } from './tabs/purchase-orders/guards/purchase-orders.guard';
import { PurchaseOrdersComponent } from './tabs/purchase-orders/purchase-orders.component';
import { VendorsGuard } from './tabs/vendors/guards/vendors.guard';
import { VendorsComponent } from './tabs/vendors/vendors.component';

// eslint-disable-next-line max-lines-per-function
export const buildBudgetRoutes = (): Route => {
  const enabledRoutes: Routes = [
    {
      children: [
        {
          canActivate: [PaymentMilestonesGuard],
          canDeactivate: [CanDeactivateGuard],
          component: PaymentMilestonesComponent,
          path: ROUTING_PATH.BUDGET.PAYMENTS.PAYMENT_MILESTONES,
        },
        {
          canActivate: [PaymentScheduleGuard],
          canDeactivate: [CanDeactivateGuard],
          component: PaymentScheduleComponent,
          path: ROUTING_PATH.BUDGET.PAYMENTS.PAYMENT_SCHEDULE,
        },
        {
          path: '**',
          redirectTo: ROUTING_PATH.BUDGET.PAYMENTS.PAYMENT_MILESTONES,
        },
      ],
      component: PaymentsComponent,
      path: ROUTING_PATH.BUDGET.PAYMENTS.INDEX,
    },
    {
      children: [
        {
          component: BudgetEnhancedComponent,
          path: ROUTING_PATH.BUDGET.BUDGET.VENDOR_BUDGET,
        },
        {
          canActivate: [BudgetLibraryGuard],
          component: BudgetLibraryComponent,
          path: ROUTING_PATH.BUDGET.BUDGET.LIBRARY,
        },
        {
          path: '**',
          redirectTo: ROUTING_PATH.BUDGET.BUDGET.VENDOR_BUDGET,
        },
      ],
      component: BudgetComponent,
      path: ROUTING_PATH.BUDGET.BUDGET.INDEX,
    },
    {
      children: [
        {
          canActivate: [ChangeOrderGuard],
          component: ChangeOrderComponent,
          path: '',
        },
        {
          canActivate: [ChangeLogGuard],
          component: CisLogComponent,
          path: ROUTING_PATH.BUDGET.CHANGE_ORDER.CHANGE_LOG,
        },
        {
          canActivate: [CompareGuard],
          component: CompareNewComponent,
          path: ROUTING_PATH.BUDGET.CHANGE_ORDER.COMPARE,
        },
        {
          canActivate: [ChangeOrderGuard],
          component: ChangeOrderDetailComponent,
          path: `:id`,
        },
      ],
      component: ChangeOrdersComponent,
      path: ROUTING_PATH.BUDGET.CHANGE_ORDER.INDEX,
    },
    {
      canActivate: [PurchaseOrdersGuard],
      canDeactivate: [CanDeactivateGuard],
      component: PurchaseOrdersComponent,
      path: ROUTING_PATH.BUDGET.PURCHASE_ORDERS,
    },
    {
      canActivate: [VendorsGuard],
      canDeactivate: [CanDeactivateGuard],
      component: VendorsComponent,
      path: ROUTING_PATH.BUDGET.VENDORS,
    },
  ];

  return {
    children: [...enabledRoutes, { path: '**', redirectTo: ROUTING_PATH.BUDGET.BUDGET.INDEX }],
    component: BudgetPageComponent,
    path: ROUTING_PATH.BUDGET.INDEX,
  };
};
